import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M9.23275 3.43744C9.54517 3.12502 10.0517 3.12502 10.3641 3.43744L15.9641 9.03744C16.2765 9.34986 16.2765 9.85639 15.9641 10.1688L10.3641 15.7688C10.0517 16.0812 9.54517 16.0812 9.23275 15.7688C8.92033 15.4564 8.92033 14.9499 9.23275 14.6374L13.4671 10.4031H4.19844C3.75661 10.4031 3.39844 10.045 3.39844 9.60313C3.39844 9.1613 3.75661 8.80312 4.19844 8.80312H13.4671L9.23275 4.56881C8.92033 4.25639 8.92033 3.74986 9.23275 3.43744Z",
  fill: "white"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render };